import type React from "react";
import styled from "styled-components";

const StyledErrorMessage = styled.div`
    color: red;
    padding: 10px;
    margin-bottom: 10px;
`;

export const ErrorMessage: React.FC<{ message: string }> = ({ message }) => (
    <StyledErrorMessage>{message}</StyledErrorMessage>
);
